export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_74d2b859-cec4-4d55-85c2-166828a23325/artifacts/fp8cu36u_LOGO%20DEPP%20C%26M.png";

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1758704961735-ded8bb22b378?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxvaWwlMjByaWclMjBuaWdodHxlbnwwfHx8fDE3NzY4MjU4MzJ8MA&ixlib=rb-4.1.0&q=85",
  about:
    "https://images.pexels.com/photos/36825977/pexels-photo-36825977.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  service_eng:
    "https://images.unsplash.com/photo-1642285709726-f9eb035b034b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxyZWZpbmVyeSUyMG5pZ2h0fGVufDB8fHx8MTc3NjgyNTgzM3ww&ixlib=rb-4.1.0&q=85",
  service_gear:
    "https://images.pexels.com/photos/32180173/pexels-photo-32180173.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  service_drill:
    "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/lh130blx_PHOTO-2026-04-21-22-53-33%205.jpg",
  service_offshore:
    "https://images.unsplash.com/photo-1569098644584-210bcd375b59?auto=format&fit=crop&w=1400&q=80",
  service_inspection:
    "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=1400&q=80",
  service_crane:
    "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&w=1400&q=80",
  service_fabrication:
    "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?auto=format&fit=crop&w=1400&q=80",
  service_hse:
    "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1400&q=80",
  project_1:
    "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/snbl7rwn_PHOTO-2026-04-21-22-58-19.jpg",
  project_2:
    "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/ksn9fkqb_PHOTO-2026-04-21-22-58-18.jpg",
  project_3:
    "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/1sim0e9j_PHOTO-2026-04-21-22-58-19%202.jpg",
  presence:
    "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1800&q=80",
};

// Real project photography uploaded by DEPP C&M.
// Append to this array as new batches arrive (5 at a time) — the Gallery renders them automatically.
export const REAL_PROJECT_PHOTOS = [
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/snbl7rwn_PHOTO-2026-04-21-22-58-19.jpg",
    tag: "Processing · Regeneration Tower",
    location: "Gas Processing Facility",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/ksn9fkqb_PHOTO-2026-04-21-22-58-18.jpg",
    tag: "Processing · Stripping Column",
    location: "Gas Treatment Skid",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/1sim0e9j_PHOTO-2026-04-21-22-58-19%202.jpg",
    tag: "Fabrication · Pressure Vessel",
    location: "Horizontal Separator",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/sfzyspnj_PHOTO-2026-04-21-22-55-24.jpg",
    tag: "Processing · Amine / Glycol Tower",
    location: "Upstream Treatment Unit",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/n9ujm9gp_PHOTO-2026-04-21-22-55-23%203.jpg",
    tag: "Inspection · Process Skid",
    location: "Mechanical Integrity Review",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/lh130blx_PHOTO-2026-04-21-22-53-33%205.jpg",
    tag: "Drilling · Rig Mobilization",
    location: "Onshore Drilling Rig",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/t19q25xw_PHOTO-2026-04-21-22-53-33%206.jpg",
    tag: "Drilling · Drawworks Package",
    location: "Rig Mobilization Yard",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/tntsk58n_PHOTO-2026-04-21-22-53-33%207.jpg",
    tag: "Drilling · Centrifuge & Mud System",
    location: "Solids Control Package",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/3mi3nli1_PHOTO-2026-04-21-22-55-23.jpg",
    tag: "Drilling · Triplex Mud Pumps",
    location: "Oilwell Mud Pump Units",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/zdhg7mac_PHOTO-2026-04-21-22-55-23%202.jpg",
    tag: "Midstream · Tank Farm",
    location: "Storage & Manifold Battery",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/5x7h9w31_PHOTO-2026-04-21-22-53-32%202.jpg",
    tag: "Drilling · Substructure Assembly",
    location: "Rig Up Operations",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/d05wfvk6_PHOTO-2026-04-21-22-53-33.jpg",
    tag: "Drilling · Rig Floor Equipment",
    location: "Drawworks & Rotary",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/rxww5e1t_PHOTO-2026-04-21-22-53-33%202.jpg",
    tag: "Drilling · Mast & Substructure",
    location: "Derrick Assembly",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/a0ck9q2q_PHOTO-2026-04-21-22-53-33%203.jpg",
    tag: "Drilling · Rig Yard",
    location: "Pre-Mobilization Inventory",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/vfb399g0_PHOTO-2026-04-21-22-53-33%204.jpg",
    tag: "Drilling · Power Package",
    location: "Generator & Engine Skid",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/3gnloz0y_PHOTO-2026-04-22-17-00-35.jpg",
    tag: "Field Operations · Rig Up",
    location: "Complete Drilling Spread",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/2zx939j4_PHOTO-2026-04-22-17-00-42.jpg",
    tag: "Field Operations · Rig Camp",
    location: "Workforce Housing & Logistics",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_energy-depp/artifacts/xw4xy2pf_PHOTO-2026-04-22-17-00-43.jpg",
    tag: "Field Operations · Operational Camp",
    location: "Integrated Field Base",
  },
];
